import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <img
        src="/assets/images/bao.png"
        alt=""
        className="pointer-events-none fixed bottom-[60px] left-[32px] z-[1] hidden lg:block"
      />
      <img
        src="/assets/images/chim.png"
        alt=""
        className="pointer-events-none fixed bottom-[55px] right-[20px] z-[1] hidden lg:block"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />

        <MatchResult />
      </div>
    </div>
  );
};

export default PrizeStructure;
